import { Injectable } from '@angular/core';
import {
  StoredAddressService as StoredAddressApiService,
} from '../../../../api/gen/api/api/storedAddress.service';
import {
  CreateStoredAddressDto,
  UpdateStoredAddressDto,
} from '../../../../api/gen/api';

@Injectable({
  providedIn: 'root',
})
export class StoredAddressService {
  constructor(private apiService: StoredAddressApiService) {}

  addStoredAddress(storedAddress: CreateStoredAddressDto) {
    return this.apiService.managementStoredAddressesPost(storedAddress);
  }

  getStoredAddress(storedAddressId: string) {
    return this.apiService.managementStoredAddressesStoredAddressIdGet(storedAddressId);
  }

  editStoredAddress(storedAddressId: string, storedAddress: UpdateStoredAddressDto) {
    return this.apiService.managementStoredAddressesStoredAddressIdPut(storedAddressId, storedAddress);
  }

  getStoredAddresses() {
    return this.apiService.managementStoredAddressesGet();
  }

  deleteStoredAddress(storedAddressId: string) {
    return this.apiService.managementStoredAddressesStoredAddressIdDelete(storedAddressId);
  }
}
